import { stringify } from "query-string"

import { farasod } from "./api"

const endpoint = "/sms-history"

export const getSmsHistoryList = async queries => {
  const query = stringify(
    queries,
    {
      skipEmptyString: true,
      skipNull: true
    }
  )

  const response = await farasod.get(`${endpoint}?${query}`)

  return response.data
}

export const getSmsHistory = async (smsHistoryId) => {
  const response = await farasod.get(`${endpoint}/${smsHistoryId}`)

  return response.data
}
